exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#collection-share-email-recipient-keyword[data-v-31232514]{display:none;width:auto;height:20px;border:none}#collection-share-email-recipient-keyword[data-v-31232514]:focus{background-color:#f8f9fa}.modal-body[data-v-31232514]{min-height:350px}", ""]);

// exports
